function formatDateDurationInDaysAndHours(dateString) {
  const date = new Date(dateString);
  const now = new Date();

  const diff = Math.abs(date - now) / 1000; // Time difference in seconds

  const days = Math.floor(diff / (24 * 60 * 60)); // Number of days
  const hours = Math.floor((diff % (24 * 60 * 60)) / (60 * 60)); // Number of hours

  return `${days}d ${hours}h`;
}

export default formatDateDurationInDaysAndHours;
